<template>
  <vue-drag-resize
    v-if="p_show"
    v-bind="$attrs"
    dragHandle=".drag"
    :h="p_height"
    :minh="c_minHeight"
    :minw="c_minWidth"
    parent-limitation
    :parentH="c_parentHeight"
    :parentW="c_parentWidth"
    :sticks="sticks"
    :w="p_width"
    :x="p_x"
    :y="p_y"
    :z="zIndex"
    @resizing="onResize"
    :isResizable="isResizable"
    :isActive="isActive"
    @activated="activateEv()"
    @deactivated="deactivateEv()"
  >
    <v-card class="full-width full-height d-flex flex-column overflow-hidden">
      <v-toolbar
        class="flex-grow-0 draggable-header--text"
        dense
        flat
        short
        color="primary lighten-2"
        dark
      >
        <v-icon
          class="drag grabbing pr-2"
          title="Nhấp chuột và kéo để di chuyển"
          >mdi-drag-variant</v-icon
        >

        <v-toolbar-title>
          <slot name="title"></slot>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="extra-btn"></slot>
        <template v-if="countPopup > 1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="isFirst"
                icon
                small
                @click="onToBack()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-arrange-send-backward</v-icon>
              </v-btn>
            </template>
            <span> Xuống dưới</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="isLast"
                icon
                small
                @click="onToFront()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-arrange-bring-forward</v-icon>
              </v-btn>
            </template>
            <span> Lên trên</span>
          </v-tooltip>
        </template>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small @click="toggleExpanded" v-bind="attrs" v-on="on">
              <v-icon small>{{
                isExpanded
                  ? 'mdi-arrow-up-drop-circle-outline'
                  : 'mdi-arrow-down-drop-circle-outline'
              }}</v-icon>
            </v-btn>
          </template>
          <span> {{ isExpanded ? 'Thu gọn' : 'Mở rộng' }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!disableClose"
              icon
              small
              @click="onClose"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </template>
          <span> Đóng </span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <div v-show="isExpanded" class="flex-grow-1 overflow-auto">
        <slot></slot>
      </div>
    </v-card>
  </vue-drag-resize>
</template>

<script>
import { isNil } from 'lodash'
import VueDragResize from 'vue-drag-resize'

import ModuleMixin from './draggable-popup.mixin'
export default {
  mixins: [ModuleMixin],
  components: {
    VueDragResize,
  },
  props: {
    minWidth: { type: Number, default: 200 },
    minHeigth: { type: Number, default: 50 },
    width: { type: Number, default: 200 },
    height: { type: Number, default: 200 },
    sticks: { type: Array, default: () => ['bl', 'br'] },
    top: { type: Number, default: undefined },
    left: { type: Number, default: undefined },
    bottom: { type: Number, default: undefined },
    right: { type: Number, default: undefined },
    isResizable: { type: Boolean, default: true },
  },
  data: () => ({
    p_show: false,
    p_width: 200,
    p_height: 200,
    p_x: 0,
    p_y: 0,
    isActive: true,
  }),
  inject: {},

  created() {
    this.p_x = 0
    this.p_y = 0
    this.p_height = this.height
    this.p_width = this.width
    if (this.show) {
      this.initPosition()
    }
  },
  watch: {
    height: {
      handler(val) {
        this.p_height = val
      },
    },
    width: {
      handler(val) {
        this.p_width = val
      },
    },
    show: {
      handler(val) {
        if (val) {
          this.initPosition()
        }

        this.p_show = val
      },
      immediate: true,
    },
  },
  computed: {
    c_show: {
      get() {
        return this.p_show
      },
      set(val) {
        this.p_show = val
        this.$emit('update:show', val)
        if (!val) {
          this.checkAndEmit('close')
        }
      },
    },
    isExpanded() {
      return this.p_height > 50
    },
    c_minWidth() {
      return this.minWidth
    },
    c_minHeight() {
      return this.minHeigth
    },
  },
  mounted() {},
  methods: {
    activateEv() {
      this.isActive = true
    },
    deactivateEv() {
      if (this.p_show) this.isActive = false
    },
    initPosition() {
      if (!isNil(this.left)) {
        this.p_x = this.left
      }
      if (!isNil(this.top)) {
        this.p_y = this.top
      }
      if (!isNil(this.right)) {
        this.p_x = this.c_parentWidth - this.right - this.p_width
      }
      if (!isNil(this.bottom)) {
        this.p_y = this.c_parentHeight - this.bottom - this.p_height
      }
    },
    toggleExpanded() {
      this.p_height = !this.isExpanded ? this.height : 50
    },
    onClose() {
      this.c_show = false
    },
    onResize(newRect) {
      this.p_width = newRect.width
      this.p_height = newRect.height
    },
  },
}
</script>

<style scoped>
.grabbing {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
</style>
